import React from 'react';
import styled from 'styled-components';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import PedidosPage from 'components/cards/Pedidos';

const PageLayout = styled.div`
	min-height: calc(100vh - 8rem);
	display: flex;
	flex-direction: column;
`;

const MainContent = styled.div`
	flex: 1;
`;

const PaginaPedidos = () => {
	return (
		<AnimationRevealPage>
			<PageLayout>
				<MainContent>
					<PedidosPage />
				</MainContent>
			</PageLayout>
		</AnimationRevealPage>
	);
};

export default PaginaPedidos;
